import ActionTypes from '../ActionTypes';

export function setValue(field, value) { // eslint-disable-line
  return {
    type: ActionTypes.Trips.setValue,
    field,
    value,
  };
}



// WEBPACK FOOTER //
// /src/store/actions/TripsActions.js